
import {
  //Home, 
  HomeMancomuno, 
  HomeParticipe,
  //HomeView,
  HomeParticipeView,
  HomeMancomunoView, 
  PageNotFound,
  PageExpired,
  PageError,
  Download
} from "../components/index";

export const routes = [
    //{ name:"Suscripcion", path: '/suscripcion/:id', component: Home, props: { data: {name: "Home", allowUpload:true, showFile:false }} },
    { name:"Participe", path: '/participe/:id', component: HomeParticipe ,props: { data: {name: "Participe", allowUpload:true, showFile:false }}},
    { name:"Mancomuno", path: '/mancomuno/:id', component: HomeMancomuno ,props: { data: {name: "Mancomuno", allowUpload:true, showFile:false }}},
    //{ name:"HomeView", path: '/view/suscripcion/:view/:id/:pro', component: HomeView, props: { data: {name: "Home", allowUpload:true, showFile:false }} },
    { name:"ParticipeView", path: '/view/participe/:view/:id/:pro', component: HomeParticipeView , props: { data: {name:"Participe", allowUpload:false, showFile:true}}},
    { name:"MancomunoView", path: '/view/mancomuno/:view/:id/:pro', component: HomeMancomunoView , props: { data:{name:"Mancomuno", allowUpload:false, showFile:true}}},
    { path: "/NotFound", name:"NotFound", component: PageNotFound },
    { path: "/Expired", name:"Expired", component: PageExpired },
    { path: "/error", name:"Error", component: PageError },
    { path: "/download", name:"Download", component: Download }
]